module.exports = __webpack_public_path__ + "static/wendi-and-lucas-anniversary-illustration-xl-6084ba265f1a5ccf333a5d570c5733c1.jpg";